import { render, staticRenderFns } from "./EditAssetType.vue?vue&type=template&id=5dd7a77c&"
import script from "./EditAssetType.vue?vue&type=script&lang=js&"
export * from "./EditAssetType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports